/* tslint:disable */
import * as Types from '../../../../../../graphql-api/gql-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type BrandOrgsQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.BrandOrgsPageQuery>;
}>;


export type BrandOrgsQuery = { brandOrgs?: { total: number, items?: Array<{ id: string, brandId: string, brandOrganisationId: string, displayName: string, isEnabled?: boolean | null } | null> | null } | null };

export const BrandOrgsDocument = gql`
    query BrandOrgs($query: BrandOrgsPageQuery) {
  brandOrgs(query: $query) {
    items {
      id
      brandId
      brandOrganisationId
      displayName
      isEnabled
    }
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BrandOrgsGQL extends Apollo.Query<BrandOrgsQuery, BrandOrgsQueryVariables> {
    document = BrandOrgsDocument;
    client = 'accounts';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }